/*
=========================================================
ASSABOOR ENTERPRISE
QUICK VIEW ENTERPRISE V2
=========================================================
*/

(() => {
  'use strict';

  class AEQuickView {
    constructor() {
      this.modal = document.querySelector(
        '[data-ae-quick-view-modal], [data-ae-quick-view]'
      );

      if (!this.modal) {
        return;
      }

      this.dialog = this.modal.querySelector(
        '.ae-qv-dialog'
      );

      this.mainImage = this.modal.querySelector(
        '[data-ae-qv-image]'
      );

      this.thumbs = this.modal.querySelector(
        '[data-ae-qv-thumbs]'
      );

      this.variantWrapper = this.modal.querySelector(
        '[data-ae-qv-options]'
      );

      this.quantityInput = this.modal.querySelector(
        '[data-ae-qv-qty]'
      );

      this.titleElement = this.modal.querySelector(
        '[data-ae-qv-title]'
      );

      this.vendorElement = this.modal.querySelector(
        '[data-ae-qv-vendor]'
      );

      this.priceElement = this.modal.querySelector(
        '[data-ae-qv-price]'
      );

      this.comparePriceElement =
        this.modal.querySelector(
          '[data-ae-qv-compare-price]'
        );

      this.descriptionElement =
        this.modal.querySelector(
          '[data-ae-qv-description]'
        );

      this.stockElement = this.modal.querySelector(
        '[data-ae-qv-stock]'
      );

      this.skuElement = this.modal.querySelector(
        '[data-ae-qv-sku]'
      );

      this.productLink = this.modal.querySelector(
        '[data-ae-qv-product-link]'
      );

      this.addButton = this.modal.querySelector(
        '[data-ae-qv-add]'
      );

      this.buyButton = this.modal.querySelector(
        '[data-ae-qv-buy]'
      );

      this.wishlistButton =
        this.modal.querySelector(
          '[data-ae-qv-wishlist]'
        );

      this.compareButton =
        this.modal.querySelector(
          '[data-ae-qv-compare]'
        );

      this.loadingElement = this.modal.querySelector(
        '[data-ae-qv-loading]'
      );

      this.errorElement = this.modal.querySelector(
        '[data-ae-qv-error]'
      );

      this.contentElement = this.modal.querySelector(
        '[data-ae-qv-content]'
      );

      this.currentProduct = null;
      this.currentVariant = null;
      this.currentImage = null;
      this.lastFocusedElement = null;
      this.isLoading = false;

      this.boundHandleClick =
        this.handleClick.bind(this);

      this.boundHandleKeydown =
        this.handleKeydown.bind(this);

      this.bindEvents();
      this.updateQuantityButtons();
    }

    bindEvents() {
      document.addEventListener(
        'click',
        this.boundHandleClick
      );

      document.addEventListener(
        'keydown',
        this.boundHandleKeydown
      );

      document.addEventListener(
        'change',
        (event) => {
          const quantityInput =
            event.target.closest(
              '[data-ae-qv-qty]'
            );

          if (quantityInput) {
            this.normalizeQuantity();
          }

          const variantSelect =
            event.target.closest(
              '[data-ae-qv-variant-select]'
            );

          if (variantSelect) {
            this.selectVariant(
              variantSelect.value
            );
          }
        }
      );

      document.addEventListener(
        'assaboor:wishlist:updated',
        () => {
          this.updateWishlistButton();
        }
      );

      document.addEventListener(
        'shopify:section:load',
        () => {
          this.refreshModalReferences();
        }
      );
    }

    refreshModalReferences() {
      const modal = document.querySelector(
        '[data-ae-quick-view-modal], [data-ae-quick-view]'
      );

      if (!modal) return;

      this.modal = modal;

      this.mainImage = modal.querySelector(
        '[data-ae-qv-image]'
      );

      this.thumbs = modal.querySelector(
        '[data-ae-qv-thumbs]'
      );

      this.variantWrapper = modal.querySelector(
        '[data-ae-qv-options]'
      );

      this.quantityInput = modal.querySelector(
        '[data-ae-qv-qty]'
      );
    }

    async handleClick(event) {
      const trigger = event.target.closest(
        '[data-ae-quick-view-trigger], [data-ae-quick-view]'
      );

      const isModalElement =
        trigger === this.modal;

      if (
        trigger &&
        !isModalElement &&
        trigger.dataset.productHandle
      ) {
        event.preventDefault();

        await this.open(
          trigger.dataset.productHandle,
          trigger
        );

        return;
      }

      if (
        event.target.closest(
          '[data-ae-qv-close]'
        )
      ) {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.target === this.modal) {
        this.close();
        return;
      }

      const thumb = event.target.closest(
        '[data-ae-qv-image-thumb], [data-image]'
      );

      if (
        thumb &&
        this.modal.contains(thumb)
      ) {
        event.preventDefault();

        this.changeImage(
          thumb.dataset.image
        );

        return;
      }

      const option = event.target.closest(
        '[data-ae-qv-variant], [data-variant]'
      );

      if (
        option &&
        this.modal.contains(option)
      ) {
        event.preventDefault();

        this.selectVariant(
          option.dataset.variant
        );

        return;
      }

      const minusButton =
        event.target.closest(
          '[data-ae-qv-qty-minus]'
        );

      if (minusButton) {
        event.preventDefault();
        this.changeQuantity(-1);
        return;
      }

      const plusButton =
        event.target.closest(
          '[data-ae-qv-qty-plus]'
        );

      if (plusButton) {
        event.preventDefault();
        this.changeQuantity(1);
        return;
      }

      const addButton =
        event.target.closest(
          '[data-ae-qv-add]'
        );

      if (addButton) {
        event.preventDefault();
        await this.addToCart(addButton);
        return;
      }

      const buyButton =
        event.target.closest(
          '[data-ae-qv-buy]'
        );

      if (buyButton) {
        event.preventDefault();
        this.buyNow();
        return;
      }

      const wishlistButton =
        event.target.closest(
          '[data-ae-qv-wishlist]'
        );

      if (wishlistButton) {
        event.preventDefault();
        this.toggleWishlist();
        return;
      }

      const compareButton =
        event.target.closest(
          '[data-ae-qv-compare]'
        );

      if (compareButton) {
        event.preventDefault();
        this.toggleCompare();
      }
    }

    handleKeydown(event) {
      if (!this.isOpen()) return;

      if (event.key === 'Escape') {
        this.close();
        return;
      }

      if (event.key === 'Tab') {
        this.trapFocus(event);
      }
    }

    async open(handle, trigger = null) {
      if (!handle || this.isLoading) return;

      this.lastFocusedElement =
        trigger || document.activeElement;

      this.setLoading(true);
      this.clearError();

      try {
        const productUrl =
          `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`;

        const response = await fetch(
          productUrl,
          {
            headers: {
              Accept: 'application/json'
            }
          }
        );

        if (!response.ok) {
          throw new Error(
            'The selected product could not be loaded.'
          );
        }

        this.currentProduct =
          await response.json();

        this.currentVariant =
          this.getInitialVariant();

        this.currentImage =
          this.currentVariant?.featured_image?.src ||
          this.currentProduct.featured_image ||
          this.currentProduct.images?.[0] ||
          '';

        this.render();

        this.modal.classList.add(
          'active',
          'is-active'
        );

        this.modal.setAttribute(
          'aria-hidden',
          'false'
        );

        document.body.classList.add(
          'overflow-hidden',
          'ae-qv-open'
        );

        requestAnimationFrame(() => {
          const focusTarget =
            this.modal.querySelector(
              '[data-ae-qv-close]'
            ) ||
            this.dialog;

          focusTarget?.focus();
        });
      } catch (error) {
        console.error(
          'Assaboor Quick View:',
          error
        );

        this.showError(
          error.message ||
            'Unable to load this product.'
        );

        this.modal.classList.add(
          'active',
          'is-active'
        );

        this.modal.setAttribute(
          'aria-hidden',
          'false'
        );
      } finally {
        this.setLoading(false);
      }
    }

    close() {
      if (!this.modal) return;

      this.modal.classList.remove(
        'active',
        'is-active'
      );

      this.modal.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.classList.remove(
        'overflow-hidden',
        'ae-qv-open'
      );

      this.currentProduct = null;
      this.currentVariant = null;
      this.currentImage = null;

      if (
        this.lastFocusedElement &&
        typeof this.lastFocusedElement.focus ===
          'function'
      ) {
        this.lastFocusedElement.focus();
      }

      this.lastFocusedElement = null;
    }

    isOpen() {
      return (
        this.modal?.classList.contains(
          'active'
        ) ||
        this.modal?.classList.contains(
          'is-active'
        )
      );
    }

    getInitialVariant() {
      if (!this.currentProduct?.variants?.length) {
        return null;
      }

      return (
        this.currentProduct.variants.find(
          (variant) => variant.available
        ) ||
        this.currentProduct.variants[0]
      );
    }

    render() {
      if (
        !this.currentProduct ||
        !this.currentVariant
      ) {
        return;
      }

      if (this.titleElement) {
        this.titleElement.textContent =
          this.currentProduct.title || '';
      }

      if (this.vendorElement) {
        this.vendorElement.textContent =
          this.currentProduct.vendor || '';

        this.vendorElement.hidden =
          !this.currentProduct.vendor;
      }

      if (this.descriptionElement) {
        this.descriptionElement.innerHTML =
          this.getCleanDescription(
            this.currentProduct.description
          );
      }

      if (this.productLink) {
        this.productLink.href =
          this.currentProduct.url ||
          `/products/${this.currentProduct.handle}`;
      }

      if (this.quantityInput) {
        this.quantityInput.value = 1;
      }

      this.renderGallery();
      this.renderVariants();
      this.updateVariantUI();
      this.updateWishlistButton();
      this.updateCompareButton();

      if (this.contentElement) {
        this.contentElement.hidden = false;
      }
    }

    renderGallery() {
      if (!this.thumbs) return;

      const images =
        this.currentProduct.images || [];

      this.thumbs.innerHTML = '';

      if (!images.length) {
        this.changeImage('');
        return;
      }

      images.forEach((image, index) => {
        const source =
          typeof image === 'string'
            ? image
            : image.src;

        const isActive =
          source === this.currentImage ||
          (!this.currentImage && index === 0);

        this.thumbs.insertAdjacentHTML(
          'beforeend',
          `
            <button
              type="button"
              class="ae-qv-thumb${
                isActive ? ' active is-active' : ''
              }"
              data-ae-qv-image-thumb
              data-image="${this.escapeAttribute(source)}"
              aria-label="View product image ${index + 1}"
              aria-pressed="${isActive ? 'true' : 'false'}"
            >
              <img
                src="${this.escapeAttribute(
                  this.resizeImage(source, 180)
                )}"
                loading="lazy"
                alt="${this.escapeAttribute(
                  this.currentProduct.title
                )}"
                width="180"
                height="180"
              >
            </button>
          `
        );
      });

      this.changeImage(
        this.currentImage || images[0]
      );
    }

    renderVariants() {
      if (!this.variantWrapper) return;

      const variants =
        this.currentProduct.variants || [];

      this.variantWrapper.innerHTML = '';

      if (
        variants.length === 1 &&
        variants[0].title ===
          'Default Title'
      ) {
        this.variantWrapper.hidden = true;
        return;
      }

      this.variantWrapper.hidden = false;

      variants.forEach((variant) => {
        const isActive =
          Number(variant.id) ===
          Number(this.currentVariant.id);

        const unavailableClass =
          variant.available
            ? ''
            : ' is-unavailable';

        this.variantWrapper.insertAdjacentHTML(
          'beforeend',
          `
            <button
              type="button"
              class="ae-qv-option${
                isActive
                  ? ' active is-active'
                  : ''
              }${unavailableClass}"
              data-ae-qv-variant
              data-variant="${variant.id}"
              aria-pressed="${
                isActive ? 'true' : 'false'
              }"
              ${
                variant.available
                  ? ''
                  : 'aria-disabled="true"'
              }
            >
              <span>
                ${this.escapeHtml(
                  variant.title
                )}
              </span>

              ${
                variant.available
                  ? ''
                  : '<small>Sold out</small>'
              }
            </button>
          `
        );
      });
    }

    selectVariant(id) {
      if (!this.currentProduct) return;

      const selectedVariant =
        this.currentProduct.variants.find(
          (variant) =>
            String(variant.id) ===
            String(id)
        );

      if (!selectedVariant) return;

      this.currentVariant =
        selectedVariant;

      this.modal
        .querySelectorAll(
          '[data-ae-qv-variant], [data-variant]'
        )
        .forEach((option) => {
          const active =
            String(option.dataset.variant) ===
            String(id);

          option.classList.toggle(
            'active',
            active
          );

          option.classList.toggle(
            'is-active',
            active
          );

          option.setAttribute(
            'aria-pressed',
            active ? 'true' : 'false'
          );
        });

      const variantSelect =
        this.modal.querySelector(
          '[data-ae-qv-variant-select]'
        );

      if (variantSelect) {
        variantSelect.value =
          selectedVariant.id;
      }

      const variantImage =
        selectedVariant.featured_image?.src;

      if (variantImage) {
        this.changeImage(variantImage);
      }

      this.updateVariantUI();
      this.updateWishlistButton();
      this.updateCompareButton();
    }

    updateVariantUI() {
      if (!this.currentVariant) return;

      this.updatePrice();
      this.updateAvailability();
      this.updateSku();
      this.updateProductLink();
      this.updateActionButtons();
    }

    updatePrice() {
      if (!this.priceElement) return;

      this.priceElement.textContent =
        this.formatMoney(
          this.currentVariant.price
        );

      const compareAtPrice =
        Number(
          this.currentVariant
            .compare_at_price || 0
        );

      const currentPrice =
        Number(
          this.currentVariant.price || 0
        );

      const onSale =
        compareAtPrice > currentPrice;

      this.priceElement.classList.toggle(
        'is-sale',
        onSale
      );

      if (this.comparePriceElement) {
        this.comparePriceElement.textContent =
          onSale
            ? this.formatMoney(
                compareAtPrice
              )
            : '';

        this.comparePriceElement.hidden =
          !onSale;
      }

      const savingElement =
        this.modal.querySelector(
          '[data-ae-qv-saving]'
        );

      if (savingElement) {
        if (onSale) {
          const saving =
            compareAtPrice -
            currentPrice;

          const percentage =
            Math.round(
              (saving /
                compareAtPrice) *
                100
            );

          savingElement.textContent =
            `Save ${percentage}%`;

          savingElement.hidden = false;
        } else {
          savingElement.hidden = true;
        }
      }
    }

    updateAvailability() {
      if (!this.stockElement) return;

      const available =
        Boolean(
          this.currentVariant.available
        );

      this.stockElement.classList.toggle(
        'is-in-stock',
        available
      );

      this.stockElement.classList.toggle(
        'is-out-of-stock',
        !available
      );

      this.stockElement.innerHTML = available
        ? `
          <span
            class="ae-qv-stock__dot"
            aria-hidden="true"
          ></span>
          In stock and ready to ship
        `
        : `
          <span
            class="ae-qv-stock__dot"
            aria-hidden="true"
          ></span>
          Currently unavailable
        `;
    }

    updateSku() {
      if (!this.skuElement) return;

      const sku =
        this.currentVariant.sku || '';

      this.skuElement.textContent = sku;
      this.skuElement.hidden = !sku;
    }

    updateProductLink() {
      if (!this.productLink) return;

      const baseUrl =
        this.currentProduct.url ||
        `/products/${this.currentProduct.handle}`;

      this.productLink.href =
        `${baseUrl}?variant=${this.currentVariant.id}`;
    }

    updateActionButtons() {
      const available =
        Boolean(
          this.currentVariant.available
        );

      if (this.addButton) {
        this.addButton.disabled =
          !available;

        this.addButton.textContent =
          available
            ? 'Add to Cart'
            : 'Sold Out';
      }

      if (this.buyButton) {
        this.buyButton.disabled =
          !available;

        this.buyButton.hidden =
          !available;
      }
    }

    changeImage(src) {
      if (!src) {
        if (this.mainImage) {
          this.mainImage.removeAttribute(
            'src'
          );

          this.mainImage.alt =
            this.currentProduct?.title || '';
        }

        return;
      }

      const imageSource =
        typeof src === 'string'
          ? src
          : src.src;

      this.currentImage = imageSource;

      if (this.mainImage) {
        this.mainImage.src =
          this.resizeImage(
            imageSource,
            1000
          );

        this.mainImage.alt =
          this.currentProduct?.title || '';

        this.mainImage.classList.add(
          'is-loading'
        );

        this.mainImage.onload = () => {
          this.mainImage.classList.remove(
            'is-loading'
          );
        };
      }

      this.modal
        .querySelectorAll(
          '[data-ae-qv-image-thumb], .ae-qv-thumb'
        )
        .forEach((thumb) => {
          const active =
            thumb.dataset.image ===
            imageSource;

          thumb.classList.toggle(
            'active',
            active
          );

          thumb.classList.toggle(
            'is-active',
            active
          );

          thumb.setAttribute(
            'aria-pressed',
            active ? 'true' : 'false'
          );
        });
    }

    changeQuantity(amount) {
      if (!this.quantityInput) return;

      const current =
        Number(
          this.quantityInput.value
        ) || 1;

      const minimum =
        Number(
          this.quantityInput.min
        ) || 1;

      const maximum =
        Number(
          this.quantityInput.max
        ) || 99;

      const nextValue = Math.min(
        maximum,
        Math.max(
          minimum,
          current + amount
        )
      );

      this.quantityInput.value =
        nextValue;

      this.updateQuantityButtons();
    }

    normalizeQuantity() {
      if (!this.quantityInput) return;

      const minimum =
        Number(
          this.quantityInput.min
        ) || 1;

      const maximum =
        Number(
          this.quantityInput.max
        ) || 99;

      const entered =
        Number(
          this.quantityInput.value
        ) || minimum;

      this.quantityInput.value =
        Math.min(
          maximum,
          Math.max(
            minimum,
            Math.floor(entered)
          )
        );

      this.updateQuantityButtons();
    }

    updateQuantityButtons() {
      if (!this.modal) return;

      const minusButton =
        this.modal.querySelector(
          '[data-ae-qv-qty-minus]'
        );

      const plusButton =
        this.modal.querySelector(
          '[data-ae-qv-qty-plus]'
        );

      const current =
        Number(
          this.quantityInput?.value
        ) || 1;

      const minimum =
        Number(
          this.quantityInput?.min
        ) || 1;

      const maximum =
        Number(
          this.quantityInput?.max
        ) || 99;

      if (minusButton) {
        minusButton.disabled =
          current <= minimum;
      }

      if (plusButton) {
        plusButton.disabled =
          current >= maximum;
      }
    }

    async addToCart(button = this.addButton) {
      if (
        !this.currentVariant ||
        !this.currentVariant.available
      ) {
        return;
      }

      const quantity =
        this.getQuantity();

      const originalText =
        button?.textContent ||
        'Add to Cart';

      if (button) {
        button.disabled = true;
        button.textContent =
          'Adding…';

        button.classList.add(
          'is-loading'
        );
      }

      try {
        const cartAddUrl =
          window.routes?.cart_add_url ||
          window.Shopify?.routes
            ?.root
            ? `${window.Shopify.routes.root}cart/add.js`
            : '/cart/add.js';

        const response = await fetch(
          cartAddUrl,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({
              id:
                this.currentVariant.id,

              quantity
            })
          }
        );

        const result =
          await response
            .json()
            .catch(() => ({}));

        if (!response.ok) {
          throw new Error(
            result.description ||
              result.message ||
              'This item could not be added to the cart.'
          );
        }

        if (button) {
          button.textContent =
            'Added ✓';
        }

        document.dispatchEvent(
          new CustomEvent(
            'assaboor:cart:refresh',
            {
              detail: {
                item: result
              }
            }
          )
        );

        document.dispatchEvent(
          new CustomEvent(
            'assaboor:cart:open',
            {
              detail: {
                item: result
              }
            }
          )
        );

        setTimeout(() => {
          this.close();

          if (
            window.AssaboorTheme
              ?.drawerManager
          ) {
            window.AssaboorTheme
              .drawerManager
              .open(
                'AECartDrawer'
              );
          }
        }, 450);
      } catch (error) {
        console.error(
          'Quick View cart error:',
          error
        );

        if (button) {
          button.textContent =
            'Try Again';

          button.classList.add(
            'has-error'
          );

          setTimeout(() => {
            button.textContent =
              originalText;

            button.classList.remove(
              'has-error'
            );

            button.disabled =
              !this.currentVariant
                .available;
          }, 1800);
        }
      } finally {
        if (button) {
          button.classList.remove(
            'is-loading'
          );

          if (
            button.textContent !==
            'Added ✓'
          ) {
            button.disabled =
              !this.currentVariant
                .available;
          }
        }
      }
    }

    buyNow() {
      if (
        !this.currentVariant ||
        !this.currentVariant.available
      ) {
        return;
      }

      const quantity =
        this.getQuantity();

      window.location.href =
        `/cart/${this.currentVariant.id}:${quantity}`;
    }

    toggleWishlist() {
      if (
        !this.currentProduct ||
        !this.currentVariant
      ) {
        return;
      }

      const wishlist =
        window.AssaboorWishlist;

      if (
        !wishlist ||
        typeof wishlist.toggle !==
          'function'
      ) {
        console.warn(
          'Assaboor Wishlist is not available.'
        );

        return;
      }

      wishlist.toggle({
        id:
          this.currentProduct.id,

        handle:
          this.currentProduct.handle,

        title:
          this.currentProduct.title,

        url:
          `${this.currentProduct.url ||
            `/products/${this.currentProduct.handle}`}?variant=${this.currentVariant.id}`,

        image:
          this.currentVariant
            .featured_image?.src ||
          this.currentProduct
            .featured_image ||
          this.currentProduct
            .images?.[0] ||
          '',

        price:
          this.formatMoney(
            this.currentVariant.price
          ),

        variant:
          this.currentVariant.id
      });

      this.updateWishlistButton();
    }

    updateWishlistButton() {
      if (
        !this.wishlistButton ||
        !this.currentProduct
      ) {
        return;
      }

      const wishlist =
        window.AssaboorWishlist;

      const active =
        wishlist &&
        typeof wishlist.exists ===
          'function'
          ? wishlist.exists(
              this.currentProduct.id
            )
          : false;

      this.wishlistButton.classList.toggle(
        'active',
        active
      );

      this.wishlistButton.classList.toggle(
        'is-active',
        active
      );

      this.wishlistButton.setAttribute(
        'aria-pressed',
        active ? 'true' : 'false'
      );

      this.wishlistButton.setAttribute(
        'aria-label',
        active
          ? 'Remove from wishlist'
          : 'Add to wishlist'
      );

      const label =
        this.wishlistButton.querySelector(
          '[data-ae-qv-wishlist-label]'
        );

      if (label) {
        label.textContent =
          active
            ? 'Saved to Wishlist'
            : 'Add to Wishlist';
      }
    }

    toggleCompare() {
      if (!this.currentProduct) return;

      const compare =
        window.AssaboorCompare;

      if (
        compare &&
        typeof compare.toggle ===
          'function'
      ) {
        compare.toggle({
          id:
            this.currentProduct.id,

          handle:
            this.currentProduct.handle,

          title:
            this.currentProduct.title,

          url:
            this.currentProduct.url ||
            `/products/${this.currentProduct.handle}`,

          image:
            this.currentProduct
              .featured_image ||
            this.currentProduct
              .images?.[0] ||
            '',

          price:
            this.formatMoney(
              this.currentVariant.price
            ),

          vendor:
            this.currentProduct.vendor ||
            ''
        });
      } else {
        document.dispatchEvent(
          new CustomEvent(
            'assaboor:compare:toggle',
            {
              detail: {
                product:
                  this.currentProduct,

                variant:
                  this.currentVariant
              }
            }
          )
        );
      }

      this.updateCompareButton();
    }

    updateCompareButton() {
      if (
        !this.compareButton ||
        !this.currentProduct
      ) {
        return;
      }

      const compare =
        window.AssaboorCompare;

      const active =
        compare &&
        typeof compare.exists ===
          'function'
          ? compare.exists(
              this.currentProduct.id
            )
          : false;

      this.compareButton.classList.toggle(
        'active',
        active
      );

      this.compareButton.classList.toggle(
        'is-active',
        active
      );

      this.compareButton.setAttribute(
        'aria-pressed',
        active ? 'true' : 'false'
      );

      const label =
        this.compareButton.querySelector(
          '[data-ae-qv-compare-label]'
        );

      if (label) {
        label.textContent =
          active
            ? 'Added to Compare'
            : 'Add to Compare';
      }
    }

    getQuantity() {
      this.normalizeQuantity();

      return (
        Number(
          this.quantityInput?.value
        ) || 1
      );
    }

    getCleanDescription(description = '') {
      const temporaryElement =
        document.createElement('div');

      temporaryElement.innerHTML =
        description;

      temporaryElement
        .querySelectorAll(
          'script, style, iframe'
        )
        .forEach((element) => {
          element.remove();
        });

      const paragraphs =
        temporaryElement.querySelectorAll(
          'p'
        );

      if (paragraphs.length > 3) {
        [...paragraphs]
          .slice(3)
          .forEach((paragraph) => {
            paragraph.remove();
          });
      }

      return temporaryElement.innerHTML;
    }

    setLoading(loading) {
      this.isLoading = loading;

      this.modal.classList.toggle(
        'is-loading',
        loading
      );

      if (this.loadingElement) {
        this.loadingElement.hidden =
          !loading;
      }

      if (
        this.contentElement &&
        loading
      ) {
        this.contentElement.hidden =
          true;
      }
    }

    showError(message) {
      if (!this.errorElement) return;

      this.errorElement.textContent =
        message;

      this.errorElement.hidden = false;
    }

    clearError() {
      if (!this.errorElement) return;

      this.errorElement.textContent = '';
      this.errorElement.hidden = true;
    }

    trapFocus(event) {
      const focusableElements =
        this.modal.querySelectorAll(
          `
            a[href],
            button:not([disabled]),
            input:not([disabled]),
            select:not([disabled]),
            textarea:not([disabled]),
            [tabindex]:not([tabindex="-1"])
          `
        );

      if (!focusableElements.length) {
        return;
      }

      const firstElement =
        focusableElements[0];

      const lastElement =
        focusableElements[
          focusableElements.length - 1
        ];

      if (
        event.shiftKey &&
        document.activeElement ===
          firstElement
      ) {
        event.preventDefault();
        lastElement.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement ===
          lastElement
      ) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    formatMoney(cents) {
      if (
        window.Shopify &&
        typeof window.Shopify
          .formatMoney === 'function'
      ) {
        try {
          return window.Shopify.formatMoney(
            cents,
            window.theme?.moneyFormat ||
              window.moneyFormat
          );
        } catch (error) {
          console.warn(
            'Shopify money formatting failed.',
            error
          );
        }
      }

      const currency =
        window.Shopify?.currency
          ?.active ||
        document.documentElement.dataset
          .currency ||
        'USD';

      return new Intl.NumberFormat(
        document.documentElement.lang ||
          'en-US',
        {
          style: 'currency',
          currency
        }
      ).format(
        Number(cents || 0) / 100
      );
    }

    resizeImage(src, width) {
      if (!src) return '';

      try {
        const url = new URL(
          src,
          window.location.origin
        );

        url.searchParams.set(
          'width',
          String(width)
        );

        return url.toString();
      } catch (error) {
        return src;
      }
    }

    escapeHtml(value = '') {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    escapeAttribute(value = '') {
      return this.escapeHtml(value);
    }
  }

  const initializeQuickView = () => {
    if (
      window.AssaboorQuickView
    ) {
      return;
    }

    window.AssaboorQuickView =
      new AEQuickView();
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeQuickView,
      {
        once: true
      }
    );
  } else {
    initializeQuickView();
  }
})();